<template>
  <div ref="rootEl" class="vue-file-transform-root"></div>
</template>

<script>
import { createApp, h, ref, onMounted, onBeforeUnmount, watch, defineComponent } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import { createMemoryHistory } from 'vue-router';
import App from './App.vue';
import { createAppRouter } from './router';
import messages, { normalizeLang, DEFAULT_LOCALE } from './i18n/messages.js';
import { AUTH_SCHEMES, setRuntimeOverride, clearRuntimeOverride } from './config/runtimeConfig.js';
import './styles/main.css';

function buildOverride(props) {
  return {
    token: props.token || '',
    baseUrl: props.apiBaseUrl || '',
    authScheme: AUTH_SCHEMES.RAW,
  };
}

export default defineComponent({
  name: 'VueFileTransformEmbedded',
  props: {
    token: { type: String, default: '' },
    lang: { type: String, default: DEFAULT_LOCALE },
    apiBaseUrl: { type: String, default: '' },
    showTitle: { type: Boolean, default: false },
  },
  setup(props) {
    const rootEl = ref(null);
    let subApp = null;
    let subI18n = null;

    setRuntimeOverride(buildOverride(props));

    onMounted(() => {
      subI18n = createI18n({
        legacy: false,
        locale: normalizeLang(props.lang),
        fallbackLocale: DEFAULT_LOCALE,
        messages,
      });
      const router = createAppRouter(createMemoryHistory());
      subApp = createApp({ render: () => h(App, { showTitle: props.showTitle, embedded: true }) });
      subApp.use(createPinia());
      subApp.use(router);
      subApp.use(subI18n);
      subApp.mount(rootEl.value);
    });

    watch(() => props.lang, (v) => {
      if (subI18n) subI18n.global.locale.value = normalizeLang(v);
    });

    watch(() => [props.token, props.apiBaseUrl], () => {
      setRuntimeOverride(buildOverride(props));
    });

    onBeforeUnmount(() => {
      if (subApp) {
        subApp.unmount();
        subApp = null;
        subI18n = null;
      }
      clearRuntimeOverride();
    });

    return { rootEl };
  },
});
</script>

<style scoped>
.vue-file-transform-root {
  height: 100%;
  min-height: 600px;
  overflow: auto;
}
</style>
